'use strict';

import GusService from "./gus-service";
import Validators from "../validators";

class GuaranteeReportForm {

    constructor() {
        this.form = '#guarante-report-create-form';
        this.formBlock = '#form-block';
        this.two_year_button = '#two_year_guarantee';
        this.three_year_button = '#three_year_guarantee';
        this.five_year_button = '#five_year_guarantee';
        this.submitButton = '#guarantee_report_form_submit';
        this.modalAcceptRulesButton = '#modal-accept-rules-button';
        this.nip = '#guarantee_report_form_nip';
        this.nipIsFromGUS = '#guarantee_report_form_nipIsFromGUS';
        this.companyName = '#guarantee_report_form_companyName';
        this.companyCity = '#guarantee_report_form_companyAddress_city';
        this.companyStreet = '#guarantee_report_form_companyAddress_street';
        this.companyNumberBuilding = '#guarantee_report_form_companyAddress_buildingNumber';
        this.companyNumberLocal = '#guarantee_report_form_companyAddress_apartmentNumber';
        this.companyPostCode = '#guarantee_report_form_companyAddress_postCode';
        this.companyPostCity = '#guarantee_report_form_companyAddress_post';
        this.formNoGuaranteeBlock = '#no-guarantee-block';
        this.guaranteeTypeDropdown = '#guarantee_report_form_guaranteeType';
        this.captcha = '#guarantee_report_form_captcha';
        this.deviceAddressCheckbox = "#guarantee_report_form_anotherDeviceAddress";
        this.acceptRodoCheckbox = "#guarantee_report_form_acceptedProcessingOfPersonalData";

        this.onChangeDeviceAddressCheckbox($(this.deviceAddressCheckbox));

        this.rodoButtonClick();
        this.onLoad();
        this.setUpListeners();
    }

    onLoad() {
        this.onClickKafel($(this.guaranteeTypeDropdown).val());
        this.blockInputIfNipFromGus();
    }

    setUpListeners() {
        $(document).on('click', this.two_year_button, () => {
            this.onClickKafel(0);
        });
        $(document).on('click', this.three_year_button, () => {
            this.onClickKafel(1);
        });
        $(document).on('click', this.five_year_button, () => {
            this.onClickKafel(2);
        });
        $(document).on('click', this.submitButton, () => {
            event.preventDefault();
        });
        $(document).on('click', this.modalAcceptRulesButton, () => {
            $(this.captcha).val(grecaptcha.getResponse());
            $(this.form).submit();
            $('#modal').modal('toggle');
        });
        $(document).on('change',this.acceptRodoCheckbox,()=>{
            this.rodoButtonClick();
        })
        $(document).on('change', this.deviceAddressCheckbox, (event) => {
            this.onChangeDeviceAddressCheckbox(event.target);
        });
        $(document).on('change', this.nip, () => {
            if (this.isNipIsFromGus()) {
                $(this.nipIsFromGUS).attr('checked', false);
                this.changeReadOnlyStatus(false);
            }
            if (Validators.nip($(this.nip).val())) {
                this.getDataFromGusAjax();
            }
        });
    }

    onClickKafel(id) {
        $(".kafle .active_checkbox").removeClass('active_checkbox');
        $(this.guaranteeTypeDropdown).val(id);
        if (id == 0) {
            $(this.two_year_button).addClass('active_checkbox');
        } else if (id == 1) {
            $(this.three_year_button).addClass('active_checkbox');
        } else if (id == 2) {
            $(this.five_year_button).addClass('active_checkbox');
        }
        this.checkGuaranteeYears();
    }

    getDataFromGusAjax() {
        let self = this;
        let url = $(this.nip).data('gusurl');
        GusService
            .getDataByNip(url, $(self.nip).val())
            .done(function (data) {
                self.setDataFromGusApi(data);
                self.changeReadOnlyStatus(true);
                $(self.nipIsFromGUS).attr('checked', true);
            })
            .fail(function () {
                self.changeReadOnlyStatus(false);
                $(self.nipIsFromGUS).attr('checked', false);
            });
    }

    setDataFromGusApi(data) {
        $(this.companyName).val(data.companyName);
        $(this.companyCity).val(data.companyCity);
        $(this.companyStreet).val(data.companyStreet);
        $(this.companyNumberBuilding).val(data.companyNumberBuilding);
        $(this.companyNumberLocal).val(data.companyNumberLocal);
        $(this.companyPostCode).val(data.companyPostCode);
        $(this.companyPostCity).val(data.companyPostCity);
    };

    changeReadOnlyStatus(status) {
        $(this.companyName).attr('readonly', status);
        $(this.companyCity).attr('readonly', status);
        $(this.companyStreet).attr('readonly', status);
        $(this.companyNumberBuilding).attr('readonly', status);
        $(this.companyNumberLocal).attr('readonly', status);
        $(this.companyPostCode).attr('readonly', status);
        $(this.companyPostCity).attr('readonly', status);
    }

    blockInputIfNipFromGus() {
        if (this.isNipIsFromGus()) {
            this.changeReadOnlyStatus(true);
        }
    }

    isNipIsFromGus() {
        return $(this.nipIsFromGUS).is(':checked');
    }

    checkGuaranteeYears() {
        if (this.isFourYearGuarantee()) {
            $(this.formBlock).hide();
            $(this.formNoGuaranteeBlock).show();
        } else {
            $(this.formBlock).show();
            $(this.formNoGuaranteeBlock).hide();
        }
    }

    onChangeDeviceAddressCheckbox(element) {
        var value = $(element).is(":checked");
        if (value === true) {
            $('#device_address_section').removeClass('d-none');
            this.setFlagDisableForDeviceAddress(false);
        } else {
            this.setFlagDisableForDeviceAddress('disabled');
            $('#device_address_section').addClass('d-none');
        }
    }

    setFlagDisableForDeviceAddress(isDisabled) {
        if (isDisabled === 'disabled') {
            this.setValueOfDeviceDataWithValue('value', "");
        }
        this.setValueOfDeviceDataWithValue('readonly', isDisabled);

    }

    setValueOfDeviceDataWithValue(property, value) {
        $('#guarantee_report_form_deviceAddress_city').prop(property, value);
        $('#guarantee_report_form_deviceAddress_street').prop(property, value);
        $('#guarantee_report_form_deviceAddress_buildingNumber').prop(property, value);
        $('#guarantee_report_form_deviceAddress_apartmentNumber').prop(property, value);
        $('#guarantee_report_form_deviceAddress_postCode').prop(property, value);
        $('#guarantee_report_form_deviceAddress_post').prop(property, value);
        $('#guarantee_report_form_deviceProvince').prop(property, value);
    }

    isFourYearGuarantee() {
        return $(this.guaranteeTypeDropdown).val() == 2;
    }

    rodoButtonClick() {
        var isChecked = $(this.acceptRodoCheckbox).is(":checked");
        var value = isChecked ? "" : "disabled";
        this.setClickableSubmitButton(value);
    }

    setClickableSubmitButton(value) {
        $('#guarantee_report_form_submit').prop('disabled', value);
    }
}

export default GuaranteeReportForm;


// WEBPACK FOOTER //
// ./assets/js/utils/guarantee-report-form.js